<script setup>
import { PageHeading, Button, Icon, Breadcrumb, Input } from '@components'

// Settings store.
import { useSettings } from '@store/settings'

const $settings = useSettings()

const capitalizeLabels = async (labels) => {
    const capitalize = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    }
    for (let key in labels) {
        if (labels[key].singular) {
            labels[key].singular = capitalize(labels[key].singular)
        }
        if (labels[key].plural) {
            labels[key].plural = capitalize(labels[key].plural)
        }
    }
}

const updateLabels = async () => {
    // Capitalize all labels before submit
    await capitalizeLabels($settings.settings.labels)

    console.log(!$settings.settings.customizer.service.title_changed)
    if (!$settings.settings.customizer.service.title_changed) {
        $settings.settings.customizer.service.title = `Select ${$settings.settings.labels.service.singular}`
    }

    if (!$settings.settings.customizer.staff.title_changed) {
        $settings.settings.customizer.staff.title = `Select ${$settings.settings.labels.staff.singular}`
    }

    console.log($settings.settings.labels)
    console.log($settings.settings.customizer)

    await $settings.saveSettings()

    Toast.success('Labels updated successfully')

    setTimeout(() => {
        window.location.reload()
    }, 500)
}


import { isSm } from '@utils/mediaQuery'


</script>

<template>
    <div class="md:max-w-[992px] m-auto mt-[-22px]">
        <!-- breadcrumb -->
        <Breadcrumb :items="[
            { icon: true, name: 'settings01', route: { name: 'settings' } },
            { name: 'Labels', route: { name: 'settings.labels' } }
        ]" />

        <!-- page title -->
        <PageHeading title="Labels" :divider="false" class="pb-9" />

        <div>
            <!-- service group -->
            <div class="md:flex md:items-center md:gap-4 px-1 py-2 md:p-5 border-b border-[#EAECF0]">
                <!-- left sidebar -->
                <div class="w-[256px] text-[#101828] text-base font-semibold" v-if="!isSm">Service</div>
                <!-- right content -->
                <div class="md:w-[736px] grid grid-cols-2 gap-4">
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Singular</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.service.singular" />
                    </div>
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Plural</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.service.plural" />
                    </div>
                </div>
            </div>

            <!-- staff group -->
            <div class="md:flex md:items-center md:gap-4 px-1 py-2 md:p-5 border-b border-[#EAECF0]">
                <!-- left sidebar -->
                <div class="w-[256px] text-[#101828] text-base font-semibold" v-if="!isSm">Staff</div>
                <!-- right content -->
                <div class="md:w-[736px] grid grid-cols-2 gap-4">
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Singular</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.staff.singular" />
                    </div>
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Plural</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.staff.plural" />
                    </div>
                </div>
            </div>

            <!-- customer group -->
            <div class="md:flex md:items-center md:gap-4 px-1 py-2 md:p-5 border-b border-[#EAECF0]">
                <!-- left sidebar -->
                <div class="w-[256px] text-[#101828] text-base font-semibold" v-if="!isSm">Customer</div>
                <!-- right content -->
                <div class="md:w-[736px] grid grid-cols-2 gap-4">
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Singular</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.customer.singular" />
                    </div>
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Plural</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.customer.plural" />
                    </div>
                </div>
            </div>

            <!-- appointment group -->
            <div class="md:flex md:items-center md:gap-4 px-1 py-2 md:p-5 border-b border-[#EAECF0]">
                <!-- left sidebar -->
                <div class="w-[256px] text-[#101828] text-base font-semibold" v-if="!isSm">Appointment</div>
                <!-- right content -->
                <div class="md:w-[736px] grid grid-cols-2 gap-4">
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Singular</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.appointment.singular" />
                    </div>
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Plural</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.appointment.plural" />
                    </div>
                </div>
            </div>

            <!-- payment group -->
            <div class="md:flex md:items-center md:gap-4 px-1 py-2 md:p-5 border-b border-[#EAECF0]">
                <!-- left sidebar -->
                <div class="w-[256px] text-[#101828] text-base font-semibold" v-if="!isSm">Payment</div>
                <!-- right content -->
                <div class="md:w-[736px] grid grid-cols-2 gap-4">
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Singular</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.payment.singular" />
                    </div>
                    <div>
                        <div class="mb-1.5 text-sm text-[#344054]">Plural</div>
                        <Input inputClass="capitalize" v-model="$settings.settings.labels.payment.plural" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer actions -->
        <div class="flex items-center gap-[42px] mt-[52px]">
            <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between"
                @click.prevent="$router.push({ name: 'settings' })">
                <div class="w-[70%]">Back</div>
                <template #before>
                    <Icon name="arrowNarrowLeft" size="20px"></Icon>
                </template>

            </Button>
            <Button @click="updateLabels()" size="xl" type="primary" radius="square"
                classButton="w-full justify-between">
                <div class="w-[95%]">Update</div>
            </Button>
        </div>
    </div>
</template>
